import React, { useEffect, useState } from 'react';
import {
  withTextLocalizer,
  getUser,
  LocalizePropType,
  isServicesTabEnabled,
  isKYCApp,
  selectUser,
  selectUserTransactions,
  clearAuth,
  isIncompleteProfile,
  selectBrandSettings,
  BrandData,
  useBubMigration,
  isUBQ,
} from 'getaway-data-layer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ProfileView from './ProfileView';
import {
  GA_TITLES,
  isMobileBrowser,
  navigateTo,
  reportGAEvent,
} from '../../../../utils';
import { PROFILE_TABS } from '../../../../enums/Profile';

type Props = {
  localize: LocalizePropType;
};

const ProfileContainer = ({ localize }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const transactions = useSelector(selectUserTransactions);
  const openTransactions =
    transactions?.transactions?.filter(
      (transaction) => transaction.status === 'open'
    ) || [];
  const brandSettings = useSelector(selectBrandSettings) as BrandData;

  const hasSyncedMerchant = user?.merchantSystemData?.find(
    (merchant) =>
      (merchant?.status === 'DONE' && merchant?.syncedAt) ||
      (merchant?.status === 'IMPORTED' && merchant?.merchantReference)
  );
  const inCompleteProfile = isIncompleteProfile(user);
  const onboardingOnlyProduct = isKYCApp();
  // For imported users, we consider readOnlyMode if they have been synced
  const readOnlyMode =
    (!inCompleteProfile || hasSyncedMerchant) && onboardingOnlyProduct;
  const isServicesLink = history?.location?.pathname?.includes('/services');
  const [activeTab, setActiveTab] = useState(
    readOnlyMode || isServicesLink
      ? PROFILE_TABS.SERVICES
      : PROFILE_TABS.ACCOUNT
  );
  const {
    migratedBubUser,
    isDeUbqShutdown,
    formattedUbqShutdownDate,
    onShutdownCTA,
    onCTA: onClickBubDialogButton,
  } = useBubMigration(isUBQ());

  const onClose = () => {
    navigateTo(history, isMobileBrowser() ? '/map' : '/');
  };

  const onDuplicateLogin = () => {
    dispatch(clearAuth());
    navigateTo(history, '/login');
  };

  useEffect(() => {
    dispatch(getUser());
    reportGAEvent(GA_TITLES.DASHBOARD.PROFILE);

    // Polling delays (in milliseconds)
    const delays = [1000, 2000, 3000, 5000, 6000, 10000];
    const timers = delays.map((delay) =>
      setTimeout(() => {
        dispatch(getUser());
      }, delay)
    );

    // Cleanup timers when the component unmounts
    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  return (
    <ProfileView
      localize={localize}
      user={user}
      migratedBubUser={migratedBubUser}
      isDeUbqShutdown={isDeUbqShutdown}
      formattedUbqShutdownDate={formattedUbqShutdownDate}
      onShutdownCTA={onShutdownCTA}
      openTransactions={openTransactions}
      onClickBubDialogButton={onClickBubDialogButton}
      onClose={onClose}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      enableServicesTab={isServicesTabEnabled()}
      onDuplicateLogin={onDuplicateLogin}
      brandSettings={brandSettings}
    />
  );
};

export default withTextLocalizer(ProfileContainer);
